export interface ServiceRequestPaymentInputState {
  nextAction?: string;
}

export const SERVICE_REQUEST_PAYMENT_INPUT = 'serviceRequestPaymentInput';

export interface ServiceRequestPaymentInputStore {
  [SERVICE_REQUEST_PAYMENT_INPUT]: ServiceRequestPaymentInputState;
}
